import { render } from "./GradesFilterer.vue?vue&type=template&id=ed91b984"
import script from "./GradesFilterer.vue?vue&type=script&lang=js"
export * from "./GradesFilterer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__